/**
 * <av-media> wraps an autoplay-capable <video> used by avocado-media.liquid.
 * Plays only while in view (perf/battery) and never autoplays when the
 * visitor has requested reduced motion.
 */
if (!customElements.get('av-media')) {
  class AvocadoMedia extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reduceMotion) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('av-media', AvocadoMedia);
}
